import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class OverlayContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
        this.hide();
    }

    init() {
        this.background = this.getChildAt(0);

        this.background.clear();
        this.background.beginFill(0x0, 1);
        this.background.drawRect(-1920 / 2, -1920 / 2, 1920, 1920);
        this.background.endFill();

        this.background.alpha = 0.7;

    }

    addListeners() {
        GlobalDispatcher.add('overlay:show', this.show, this);
        GlobalDispatcher.add('overlay:hide', this.hide, this);
        GlobalDispatcher.add('scaleManager:resize', this.onGameResized, this, 0);
    }

    onGameResized(event) {
        let scale = Math.max(event.params.canvasWidth, event.params.canvasHeight) / 1920;
        this.scale.set(scale, scale);
        this.y = event.params.canvasHeight / 2;

        setTimeout(()=>{
            this.y -= this.parent.y;
        }, 100);
    }

    show() {
        GlobalDispatcher.dispatch('overlay:showed');
        this.visible = true;
    }

    hide() {
        GlobalDispatcher.dispatch('overlay:hided');
        this.visible = false;
    }
}